"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("documentRequests").controller("DocumentRequestCtrl", DocumentRequestCtrl);

  function DocumentRequestCtrl($rootScope, $scope, $controller, $timeout, FormlyService, DocumentRequestsService, params) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "DocumentRequestCtrl";

    vm.log = debug("pages:documentRequest");

    vm.createFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return localforage.getItem("oneAtATime");

            case 2:
              vm.oneAtATime = _context.sent;


              vm.rows = [{
                columns: [{
                  class: "col-xs-12 col-sm-4 col-md-4",
                  boxes: []
                }, {
                  class: "col-xs-12 col-sm-4 col-md-4",
                  boxes: [{
                    mainTitle: "Informations",
                    fields: [FormlyService.text("contactName", "Nom du contact", true, {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.text("email", "Email du contact", true, {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.text("phone", "Portable du contact", true, {
                      className: "col-xs-12 col-sm-12"
                    })]
                  }]
                }]
              }];

              $timeout(function () {}, 0);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.check = function () {
      var save = true;

      if (!vm.model.contactName) {
        Notiflix.Notify.failure("Veuillez indiquer le nom du contact.");
        save = false;
      }
      if (!vm.model.email && !vm.model.phone) {
        Notiflix.Notify.failure("Veuillez indiquer un email ou un portable.");
        save = false;
      }
      if (vm.model.email && !vm.validateEmail(vm.model.email)) {
        Notiflix.Notify.failure("Le format de l'email n'est pas correct.");
        save = false;
      }
      if (vm.model.phone) {
        var phone = vm.model.phone.replace(/[\s.\-()]/g, "");
        if (/^00[1-9]\d{6,13}$/.test(phone)) {
          phone = "+" + phone.slice(2);
        } else if (/^0\d{9}$/.test(phone)) {
          phone = "+33" + phone.slice(1);
        }
        if (/^\+[1-9]\d{6,14}$/.test(phone)) {
          vm.model.phone = phone;
        } else {
          Notiflix.Notify.failure("Le format du portable n'est pas correct.");
          save = false;
        }
      }

      if (save) {
        vm.save();
      }
    };

    vm.validateEmail = function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    vm.ready = function () {
      vm.createFields();
    };

    $controller("CreateBaseController", {
      vm: vm,
      $scope: $scope,
      service: DocumentRequestsService,
      listPage: "documentRequests",
      nameModel: "une demande",
      params: params
    });
  }
})();